module.exports = __webpack_public_path__ + "static/media/assa-provider.6240c167.svg";